import { setHours, startOfHour } from 'date-fns';

export class DateHelper {
  static setarDataMeioDia(date: Date): Date {
    return setHours(startOfHour(new Date(date)), 12);
  }
}
